export const testimonials = [
  {
    name: "Jessica Parker",
    quote:
      "Whizmanage is an absolute game-changer. It streamlined our entire product management process, saving us hours every day.",
    src: "https://i.pravatar.cc/150?img=1",
    designation: "E-commerce Specialist",
  },
  {
    name: "Rachel Green",
    quote:
      "Creating and managing products has never been easier. Whizmanage has revolutionized the way we run our store.",
    src: "https://i.pravatar.cc/150?img=2",
    designation: "Retail Business Owner",
  },
  {
    name: "Michael Brown",
    quote:
      "The efficiency and ease of use are unparalleled. It's like having an extra team member dedicated to optimizing our store.",
    src: "https://i.pravatar.cc/150?img=3",
    designation: "Senior Product Manager",
  },
  {
    name: "Laura Thompson",
    quote:
      "Absolutely fantastic! Whizmanage has boosted our productivity and allowed us to focus on growing our business.",
    src: "https://i.pravatar.cc/150?img=4",
    designation: "Operations Manager",
  },
  {
    name: "Emily Johnson",
    quote:
      "I can't imagine managing our store without Whizmanage. It's intuitive, powerful, and indispensable.",
    src: "https://i.pravatar.cc/150?img=5",
    designation: "E-commerce Director",
  },
  {
    name: "Ethan Harris",
    quote:
      "Whizmanage has turned product management from a chore into a delight. Highly recommend it to all store owners.",
    src: "https://i.pravatar.cc/150?img=6",
    designation: "Digital Marketing Manager",
  },
  {
    name: "Daniel Lee",
    quote:
      "An essential tool for anyone serious about their online store. The automation and analytics are top-notch.",
    src: "https://i.pravatar.cc/150?img=7",
    designation: "Technology Consultant",
  },
  {
    name: "Jacob Martinez",
    quote:
      "The best investment we've made in our business. Whizmanage's features are incredibly powerful and user-friendly.",
    src: "https://i.pravatar.cc/150?img=8",
    designation: "Retail Store Owner",
  },
  {
    name: "Amanda Taylor",
    quote:
      "Whizmanage has significantly improved our workflow. The ability to quickly edit and manage products is a lifesaver.",
    src: "https://i.pravatar.cc/150?img=9",
    designation: "Logistics Coordinator",
  },
  {
    name: "Olivia King",
    quote:
      "Our sales have increased since we started using Whizmanage. The comprehensive analytics provide valuable insights.",
    src: "https://i.pravatar.cc/150?img=10",
    designation: "Sales Manager",
  },
  {
    name: "Samuel Carter",
    quote:
      "From managing inventory to tracking orders, Whizmanage does it all. It's a must-have tool for any e-commerce business.",
    src: "https://i.pravatar.cc/150?img=11",
    designation: "Warehouse Manager",
  },
  {
    name: "Henry Lewis",
    quote:
      "I never thought product management could be this easy. Whizmanage has transformed the way we operate.",
    src: "https://i.pravatar.cc/150?img=12",
    designation: "Creative Director",
  },
  {
    name: "Jacob Clark",
    quote:
      "A robust and reliable tool that fits perfectly into our workflow. Whizmanage has enhanced our capabilities tremendously.",
    src: "https://i.pravatar.cc/150?img=13",
    designation: "Project Manager",
  },
  {
    name: "Anthony Walker",
    quote:
      "Whizmanage is intuitive and powerful. It has saved us countless hours and improved our overall efficiency.",
    src: "https://i.pravatar.cc/150?img=14",
    designation: "Product Specialist",
  },
  {
    name: "Noah Robinson",
    quote:
      "Simply amazing! Whizmanage has allowed us to manage our store more effectively and focus on what really matters.",
    src: "https://i.pravatar.cc/150?img=15",
    designation: "Chief Operating Officer",
  },
  {
    name: "Liam Young",
    quote:
      "Whizmanage has taken our product management to the next level. It's a vital part of our daily operations.",
    src: "https://i.pravatar.cc/150?img=16",
    designation: "E-commerce Coordinator",
  },
  {
    name: "George Bennett",
    quote:
      "A game-changer for our business. The insights and tools provided by Whizmanage have driven significant growth.",
    src: "https://i.pravatar.cc/150?img=17",
    designation: "Growth Strategist",
  },
  {
    name: "Frank Moore",
    quote:
      "The support team is exceptional. They ensure we maximize the potential of Whizmanage in our operations.",
    src: "https://i.pravatar.cc/150?img=18",
    designation: "Client Support Lead",
  },
  {
    name: "Victoria Collins",
    quote:
      "Whizmanage has put us ahead of the competition. It's the future of e-commerce management, today.",
    src: "https://i.pravatar.cc/150?img=19",
    designation: "Market Analyst",
  },
  {
    name: "Sophia Turner",
    quote:
      "It has transformed our daily tasks. Whizmanage is incredibly efficient and easy to use, even for non-techies.",
    src: "https://i.pravatar.cc/150?img=20",
    designation: "Customer Service Manager",
  },
  {
    name: "Emily White",
    quote:
      "Our operations have never been smoother. Whizmanage's capabilities are unmatched, making it a crucial tool for us.",
    src: "https://i.pravatar.cc/150?img=21",
    designation: "Operations Specialist",
  },
  {
    name: "Eva Green",
    quote:
      "Whizmanage has completely changed the way we manage our store. It's a phenomenal tool that delivers on its promises.",
    src: "https://i.pravatar.cc/150?img=22",
    designation: "Retail Operations Manager",
  },
];